import { createContext } from 'react';

export interface ProductTourContextValue {
  isActive: boolean;
  restartTour: () => void;
}

export const ProductTourContext = createContext<ProductTourContextValue>({
  isActive: false,
  restartTour: () => undefined,
});
